module.exports = "<i class=\"js-clear-button editor__icons icon-remove fal fa-times\"></i>\n";